// The final per-piece approval's routes (server: dashboard/piecePublish.js).
const BASE = 'photo-pipeline/publish';

export const getPublishPieces = fetchResource => fetchResource({ method: 'GET', resource: `${BASE}/pieces`, loadingKey: 'publishList' });
// Quiet: the preview explains its own failures, and a live piece's 409 is an answer.
// `description` ('live' | 'generated'): a republish's choice; the server
// defaults to 'live', so a first publish never sends one.
export const getPiecePreview = (fetchResource, sku, description) =>
    fetchResource({
        method: 'GET',
        resource: description ? `${BASE}/${sku}/preview?description=${description}` : `${BASE}/${sku}/preview`,
        loadingKey: 'preview',
        quiet: true,
    });
// `version` is the preview's: the server refuses (409, with the current one)
// when the shots changed since it was shown. A republish also names its
// description, and `version` must be the hash for that choice.
// Quiet: the preview shows the outcome.
export const approveAndPublish = (fetchResource, sku, version, description) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/approve`, body: description ? { version, description } : { version }, quiet: true });
// Every approved shot of the piece back to review. Quiet: the preview shows the outcome.
export const sendBackPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/send-back`, quiet: true });
// "Reopen piece" (photoPipeline/reopen.js): a live piece back to review, its
// live photos as "Live version"s. Nothing on the site changes until the piece
// is approved again. Quiet: the dialog words each refusal.
export const reopenPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/reopen`, quiet: true });
// "Cancel reopen": every shot back exactly as published. Quiet: the notice
// shows the server's reason when it refuses.
export const cancelReopen = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `${BASE}/${sku}/cancel-reopen`, quiet: true });
// The upload page's "Do you want to reshoot it?" → Yes: the same reopen in
// reshoot mode, at the clerk's tier. Quiet: the dialog shows a refusal.
export const reshootPiece = (fetchResource, sku) =>
    fetchResource({ method: 'POST', resource: `photo-pipeline/reshoot/${sku}`, quiet: true });
